import React, { useState ,useEffect } from "react";
import { FaUser,FaPhone, FaEnvelope,FaShieldAlt, FaCheckCircle, FaUserCheck, FaUserTimes, FaBuilding, FaMapMarkerAlt,  FaFileInvoice, FaImage,  FaIdCard, FaFilePdf,FaSearch,FaPlus,FaTimes
} from "react-icons/fa";
import axios from 'axios'
import toast from "react-hot-toast";
import { useNavigate , useLocation } from "react-router-dom";


function DealerPartsQuotation({token}) {
    const navigate = useNavigate();

  const location = useLocation();
  const dealer = location.state?.dealer;



   const [searchTerm, setSearchTerm] = useState('');
    const [showForm, setShowForm] = useState(false);
      const[list,setList] = useState([]);
    const [showSaleModal, setShowSaleModal] = useState(false);
    const [selectedDealer, setSelectedDealer] = useState("");  

       const CustomerWiseEnq = async () => {
  try {
    const res = await axios.get(`https://api.krimotion.in/get-parts-quotation/${dealer.id}`,
       {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }
    )
    const result = res.data;

    console.log(result);
 
    setList(result);
  } catch (error) {
    console.log(error);
  }
};

   useEffect(() => {
    CustomerWiseEnq();

  }, []);


  
    const handleMarkReceived = async () => {
  try {
    await axios.put(
      `https://api.krimotion.in/mark-sale/${selectedDealer.id}`,
      {
        status: "Received",
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    toast.success("Enquiry marked as sale successfully.");

    setShowSaleModal(false);

    // Refresh list
    CustomerWiseEnq();
  } catch (error) {
    console.error(error);
    toast.error("Failed to mark enquiry as sale.");
  }
};

     const filteredData = Array.isArray(list)
    ? list.filter(itm =>
      Object.values(itm).some(val =>
        String(val).toLowerCase().includes(searchTerm.toLowerCase())
      )
    )
    : [];

const formatDate = (date) => {
  if (!date) return "-";

  const d = new Date(date);

  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();

  let hours = d.getHours();
  const minutes = String(d.getMinutes()).padStart(2, "0");

  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12; 
  hours = String(hours).padStart(2, "0");

  return `${day}-${month}-${year} ${hours}:${minutes} ${ampm}`;
};

  return (
<>

   <div className="container py-4">
               <div className="border-0  mb-3 px-2 py-2  ">
                 
                 <div className="d-flex flex-column gap-2">

  {/* TOP ROW: Title + Search */}
  <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">

    <h4 className="fw-bold mb-0" style={{ fontSize: "20px" }}>
     Dealer Quoataion  List
    </h4>

    <div style={{ flex: 1, maxWidth: "250px" }}>
      <div
        className="d-flex align-items-center rounded-pill overflow-hidden"
        style={{
          border: "1px solid var(--green)",
          height: "34px",
          paddingLeft: "8px",
          paddingRight: "8px",
          backgroundColor: "white"
        }}
      >
        <FaSearch style={{ color: "var(--green)", fontSize: "14px" }} />

        <input
          type="text"
          className="form-control border-0 shadow-none"
          placeholder="Search..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{
            fontSize: "14px",
            height: "32px",
            marginLeft: "6px"
          }}
        />
      </div>
    </div>

  </div>

  {/* SECOND ROW: Back Button */}
  <div>
    <button
      className="btn btn-outline-secondary btn-sm"
      onClick={() => navigate(-1)}
    >
      ← Back
    </button>
  </div>

</div>


                 </div>
        <h5>
  <span className="status-badge status-success px-3 py-2">
    {dealer.cust_name}
  </span>
</h5>
     
                   {/* {!showForm && (
                              <>
                          <div className="card shadow-lg border-0 rounded-4 mt-4 overflow-hidden " style={{ background: '#f4f6f9'}}>
                      
                            <div className="card-body p-3">
                                     <div className="table-responsive">
                           <table className="table table-hover align-middle mb-0 text-center">
                             <thead  >
                               <tr>
                               
                            
                                 <th className=" text-white" style={{backgroundColor:'var(--green)'}}>Dealer Name</th>
                                 <th className=" text-white" style={{backgroundColor:'var(--green)'}}>Phone</th>
                            
                                   <th className=" text-white" style={{backgroundColor:'var(--green)'}}>Discount </th> 

                                       <th className=" text-white" style={{backgroundColor:'var(--green)'}}>Amount </th> 
                            <th className=" text-white" style={{backgroundColor:'var(--green)'}}>Quotation Date </th>    
                                                    
                          <th className=" text-white" style={{backgroundColor:'var(--green)'}}>Quotation Status </th>                        

          
                               </tr>
                             </thead>
                     
                             <tbody>
                               {filteredData.length > 0 ? (
                                 filteredData.map((dealer, index) => (
                                   <tr key={index}>
                           
                                     <td>{dealer.buss_name}</td>
                                     <td>{dealer.mobile}</td>
                                        <td>{dealer.discount}</td>
                                   <td>{dealer.final_amount} </td>
                       
                              <td>{formatDate(dealer.quote_date)} </td>
                             <td>{dealer.quote_status} </td>
                                
                            
                           </tr>
                                 ))
                               ) : (
                                 <tr>
                                   <td colSpan="8" className="text-center py-4">
                                     No List Found
                                   </td>
                                 </tr>
                               )}
                             </tbody>
                 
                           </table>
                         </div>
                            </div> 

                       </div>
                     
                         </>
                              )} */}

                              {!showForm && (
  <div className="container-fluid mt-4">
    <div className="row g-4">

      {filteredData.length > 0 ? (
        filteredData.map((dealer, index) => (

          <div className="col-xl-4 col-lg-6 col-md-6" key={index}>

            <div className="inventory-card d-flex flex-column h-100">

              {/* Header */}
              <div className="d-flex justify-content-between align-items-start">

                <div>
                  <h5 className="inventory-title mb-1">
                    {dealer.buss_name}
                  </h5>

                  <small className="text-muted">
                    {dealer.mobile}
                  </small>
                </div>

                <span
                  className={`badge ${
                    dealer.quote_status === "Accepted"
                      ? "bg-success"
                      : dealer.quote_status === "Rejected"
                      ? "bg-danger"
                      : "bg-warning text-dark"
                  }`}
                >
                  {dealer.quote_status}
                </span>

              </div>

              <hr />

              {/* Details */}

              <div className="inventory-row">
                <span className="inventory-label">
                  Discount
                </span>
                <span>{dealer.discount}</span>
              </div>

              <div className="inventory-row">
                <span className="inventory-label">
                  Final Amount
                </span>
                <span className="fw-bold text-success">
                  ₹ {dealer.final_amount}
                </span>
              </div>

              <div className="inventory-row">
                <span className="inventory-label">
                  Quotation Date
                </span>
                <span>{formatDate(dealer.quote_date)}</span>
              </div>

              <div className="inventory-row">
                <span className="inventory-label">
                  Status
                </span>

                <span
                  className={`status-badge ${
                    dealer.quote_status === "Accepted"
                      ? "status-success"
                      : dealer.quote_status === "Rejected"
                      ? "status-danger"
                      : "status-warning"
                  }`}
                >
                  {dealer.quote_status}
                </span>

              </div>

            </div>

          </div>

        ))
      ) : (
        <div className="col-12">
          <div className="text-center py-5">
            <h5>No List Found</h5>
          </div>
        </div>
      )}

    </div>
  </div>
)}

                              {showSaleModal && (
  <>
    <div
      className="modal-backdrop fade show"
      onClick={() => setShowSaleModal(false)}
    ></div>

    <div className="modal fade show d-block">
      <div className="modal-dialog modal-dialog-centered">
        <div
          className="modal-content border-0 shadow-lg"
          style={{ borderRadius: "16px" }}
        >
          {/* Header */}
          <div className="modal-header bg-primary text-white">
            <h5 className="modal-title fw-bold">
              📦 Mark as Received
            </h5>

            <button
              className="btn-close btn-close-white"
              onClick={() => setShowSaleModal(false)}
            ></button>
          </div>

          {/* Body */}
          <div className="modal-body text-center py-4">
            <div style={{ fontSize: "55px" }}>📦</div>

            <h5 className="mt-3 fw-bold">
              Confirm Item Received
            </h5>

            <p className="text-muted mb-2">
              Are you sure you want to mark this item as
              <strong> received by the customer</strong>?
            </p>

            <p className="text-primary fw-semibold">
              This will update the enquiry status to <strong>"Received"</strong>.
            </p>
          </div>

          {/* Footer */}
          <div className="modal-footer border-0 justify-content-center">
            <button
              className="btn btn-outline-secondary px-4"
              onClick={() => setShowSaleModal(false)}
            >
              Cancel
            </button>

            <button
              className="btn btn-primary px-4"
              onClick={handleMarkReceived}
            >
              📦 Mark as Received
            </button>
          </div>
        </div>
      </div>
    </div>
  </>
)}
         </div>
</>
  )
}

export default DealerPartsQuotation
